import { Box, Typography, useTheme } from "@mui/material";

/**
 * Which aircraft this log came off.
 *
 * Every field here is read at parse time by the backend — the board and its uid
 * from ArduPilot's boot banner or a ULog's `ver_hw`/`sys_uuid` header, the frame
 * from the banner that follows. Nothing is parsed in the browser: doing so
 * missed every PX4 log, since PX4 prints no banner at all.
 *
 * `board_uid` is served only on the owner's own single-log read, so this renders
 * the uid when the API supplied one and stays quiet when it did not. There is no
 * flag to get wrong here — the field is simply absent.
 */
const HardwareId = ({ log }) => {
  const theme = useTheme();
  // A telemetry log names no board, and logs parsed before the board was
  // recorded name none either. Both say nothing rather than guess.
  if (!log?.board_model) return null;
  const frame = log.summary?.board?.frame;

  return (
    <Typography variant="caption" sx={{ display: "block", color: theme.palette.text.secondary }}>
      FLIGHT CONTROLLER{" "}
      <Box component="span" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
        {log.board_model}
      </Box>
      {frame ? ` · ${frame}` : ""}
      {log.board_uid ? (
        <>
          {" · UID "}
          <Box component="span" sx={{ fontFamily: "monospace" }}>
            {log.board_uid}
          </Box>
        </>
      ) : null}
    </Typography>
  );
};

export default HardwareId;
